// extracted by mini-css-extract-plugin
export default {"arrowColor":"#44cc94","column":"column__17qJF","content":"content__SVXjw","newOrderButton":"newOrderButton__1Cw71"};
    if(module.hot) {
      // 1764953330155
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  